import { FilterByColumnQuery, numberFilterCondition } from '.'
import { getQFromQuery } from '../../utils'
import { FilterText, FilterTypes } from '../types'

export const generateQuery = ({
  sourceDataset,
  sourceColumn,
  filterType,
  filterTextType,
  filterNumberType,
  filterNumberFirst,
  filterNumberSecond,
  filterValue,
  withAs,
  from
}: FilterByColumnQuery) => {
  let where = ''
  const nextQNumber = getQFromQuery(withAs) + 1
  if (filterType === FilterTypes.Text && filterValue) {
    const cols = filterValue.map((v) => `${v}`).join('|')
    const expression = filterTextType === FilterText.Equal ? '~*' : '!~*'
    where = `${sourceColumn} ${expression} '${cols}'`
  } else {
    where = numberFilterCondition({
      provider: sourceDataset?.providerId,
      sourceColumn,
      filterNumberType,
      filterNumberFirst,
      filterNumberSecond
    })
  }
  return where && from
    ? `${withAs},
__q${nextQNumber} AS (
\tSELECT * FROM ${from} WHERE ${where}
)
SELECT * FROM __q${nextQNumber}`
    : ''
}
